//i18n-setup.js
import { createI18n, I18nOptions } from 'vue-i18n'
import CustomFormatter from './i18n-custom-formatter'
const config = { formatter: new CustomFormatter() } as I18nOptions
if (process.env.NODE_ENV === 'development') {
  config.missing = () => { return; }
}

export const i18n = createI18n(config);
i18n.global.silentTranslationWarn = process.env.NODE_ENV === 'development'